import PropTypes from 'prop-types'
import Button from '@mui/material/Button'
import { useTranslation } from 'gatsby-plugin-react-i18next'

import FlickrIcon from 'icons/FlickrIcon'

const FLICKR_ALBUMS = {
  '2015 May, Greece × Istanbul, Turkey': '72157651798475663',
  '2015 November, Bali, Indonesia': '72157658886930264',
  '2016 May, Italy × Slovenia': '72157668200851890',
  '2017 September, Taipei, Taiwan (ROC)': '72157684949566502',
  '2017 October, Nepal': '72157688357268154',
  '2018 March, China': '72157665791663237',
  '2018 November, Yangon, Myanmar': '72157673208048167',
  '2019 October, Uzbekistan': '72157711623203861',
  '2021 April, Da Lat, Vietnam': '72157719174926545',
  '2022 January, Da Lat, Vietnam': '72177720297319698',
  '2022 May, India': '72177720299970225',
  '2022 October, South Korea': '72177720303477248',
  '2023 April, Chiang Mai, Thailand': '72177720308085334',
  '2023 May, Quy Nhon, Vietnam': '72177720308789619',
  '2023 November, Ethiopia': '72177720312716464',
  '2024 September, Mongolia': '72177720320265515',
  '2025 April, Oman': '72177720325333704',
  'Berlin, Germany': '72157693911946964',
  'Perth, Australia': '72157715998373932'
}

function FlickrButton({ sx, flickrAlbum }) {
  const { t } = useTranslation()

  return (
    <Button
      variant="outlined"
      color="inherit"
      size="large"
      href={`https://www.flickr.com/photos/zuyetawarmatik/albums/${FLICKR_ALBUMS[flickrAlbum]}`}
      target="_blank"
      rel="noopener noreferrer"
      sx={[
        { gap: 1.5 },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <FlickrIcon fontSize="1em" />
      {t('postFooter.goToFlickrAlbum')}
    </Button>
  )
}

FlickrButton.propTypes = {
  sx: PropTypes.object,
  flickrAlbum: PropTypes.string
}

FlickrButton.defaultProps = {
  sx: undefined
}

export default FlickrButton
